import type { MenuOptionGroup } from "@/types";

/** Match the POS modifier engine's effective group quantity bounds. */
export const modifierBounds = (group: MenuOptionGroup) => {
  const optionsLength = group.options?.length ?? 0;
  const minEff = Math.max(
    Number(group.min_num_options ?? 0),
    Number(group.min_aggregate_options_quantity ?? 0),
  );
  const configuredMax = Math.max(
    Number(group.max_num_options ?? 0),
    Number(group.max_aggregate_options_quantity ?? 0),
  );
  const maxEff = configuredMax || optionsLength;
  return { minEff, maxEff, isRequired: minEff > 0 };
};
